<template>
	<div>
		<!-- 视频 -->
		<div class="Minister-top information" v-show="isShowBiaoti || isShowChanpin || isShowFengmian">
			<div class="Minister-top-top Ministerbackground">
				<div class="Minister-top-left Minister-top-color">视频</div>
			</div>
			<div class="information_content">
				<div class="information_input" style="margin-bottom:10px;"  v-show="isShowBiaoti">
					<div class="information_Title">
						视频标题
						<el-tooltip placement="right-start" v-show="formData.biaotiDescription">
						<div slot="content" class="el_tip_box">
							{{formData.biaotiDescription}}
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>
					</div>
					<div class="input_el input_span">
						<div class="newipt">
							<el-input
									style="margin-left: 10px"
									type="textarea"
									class="width85"
									placeholder="请输入视频标题"
									v-model="formData.title"
									autosize
									show-word-limit
									:disabled="system < 5 || isChakan"
							></el-input>
						</div>
					</div>
				</div>

				<div class="information_input"   v-show="isShowChanpin">
					<div class="information_Title">
						产品视频
						<el-tooltip placement="right-start" v-show="formData.chanpinDescription">
							<div slot="content" class="el_tip_box">
								{{formData.chanpinDescription}}
							</div>
							<img :src="urlQueImg" class="item_img" alt/>
						</el-tooltip>
					</div>
					<div class="flex_el_88" style="display: flex;width: 88%">
						<el-upload class="upload-container" ref="uploadMultiple" :action="action" :on-remove="handleRemove"
								   :on-success="handleSuccess" :headers="customHeaders" style="margin-left: 10px;"
								   name="multipartFile" multiple :show-file-list="false" v-if="system == 5 && !isChakan">
							<el-button type="primary" @click="beforeUpload('chanpin')">视频上传</el-button>
						</el-upload>
						<el-button style="margin-left: 5px" v-if="chanpinUrl" type="primary" @click="clickView('chanpin')">查看</el-button>

						<span style="background: rgb(240,249,180);margin-left:15px;padding: 3px 5px;font-size: 12px" v-if="chanpinUrl && system == 5 && !isChakan">“服装”类别使用纵横比为3:4的垂直视频。对于其他类别，应使用纵横比为1:1（正方形）的视频。</span>
					</div>
				</div>
				<div class="information_input"   v-show="isShowFengmian">
					<div class="information_Title">
						封面视频
						<el-tooltip placement="right-start" v-show="formData.fengmianDescription">
							<div slot="content" class="el_tip_box">
								{{formData.fengmianDescription}}
							</div>
							<img :src="urlQueImg" class="item_img" alt/>
						</el-tooltip>
					</div>
					<div class="flex_el_88" style="display: flex;width: 88%;margin-top: 10px">
						<el-upload class="upload-container" ref="uploadMultiple" :action="action" :on-remove="handleRemove"
								   :on-success="handleSuccess" :headers="customHeaders" style="margin-left: 10px;"
								   name="multipartFile" multiple :show-file-list="false" v-if="system == 5 && !isChakan">
							<el-button type="primary" @click="beforeUpload('fengmian')">视频上传</el-button>
						</el-upload>
						<el-button style="margin-left: 5px" v-if="fengmianUrl" type="primary" @click="clickView('fengmian')">查看</el-button>
						<span style="background: rgb(240,249,180);margin-left:15px;padding: 3px 5px;font-size: 12px" v-if="chanpinUrl && system == 5 && !isChakan">大小不能超过20MB，视频时长不能超过30秒，请将时长较长的视频上传到产品视频。</span>
					</div>
				</div>
				<div style="margin-left: 9%;margin-top: 10px;font-size: 12px" v-if="chanpinUrl && system == 5 && !isChakan">
					因视频文件会占用大量服务器存储资源请视频
					<span style="color: red">上传3天内完成产品发布</span>，未发布的产品视频将会被清除。
				</div>
			</div>
		</div>

		<el-dialog
				:title="title"
				:visible.sync="dialogVideoVisible"
				:modal-append-to-body="false"
				append-to-body
				width="800px"
				top="6vh"
		>
			<video
					v-if="dialogVideoVisible"
					:src="videoUrl"
					controls
					autoplay
					loop
					muted
					style="width: 100%; height: 500px"
			></video>
			<span slot="footer" style="margin-top: 60px">
					<el-button type="primary" @click="dialogVideoVisible = false">确 认</el-button>
					<el-button @click="dialogVideoVisible = false">关 闭</el-button>
  			</span>
		</el-dialog>

	</div>


</template>
<script>
	import {ajaxPost, Baseurl} from "../../../../api/api/api";
	export default {
		name: 'shipinComp',
		props: {
			score: {
				type: Array,
				default() {
					return [0,0,0,0];
				},
			}
		},
		data() {
			return {
				title:'',
				dialogVideoVisible:false,
				system:5,
				//是否为查看
				isChakan:false,
				type:'fengmian',
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),
				action: Baseurl + "imageController/uploadFile",
				customHeaders: { token: localStorage.getItem("token") },
				formData:{
					title:'',
					biaotiDescription:'',
					chanpinDescription:'',
					fengmianDescription:'',
				},
				chanpinUrl:'',
				fengmianUrl:'',
				isShowBiaoti:false,
				isShowChanpin:false,
				isShowFengmian:false,
				videoUrl:'',
			}
		},
		created() {
			this.system = JSON.parse(localStorage.getItem('role')).system
			this.isShowBiaoti = false
			this.isShowChanpin = false
			this.isShowFengmian = false
		},
		methods: {
			clickView(type){
				if (type == 'chanpin'){
					this.videoUrl = this.chanpinUrl
					this.title = '产品视频'
				}
				if (type == 'fengmian'){
					this.videoUrl = this.fengmianUrl
					this.title = '封面视频'
				}
				this.dialogVideoVisible = true
			},
			//修改内容
			editSpDesc(item,type){
				if (type == 'biaoti'){
					this.formData.biaotiDescription = item
					this.isShowBiaoti = true
				}
				if (type == 'chanpin'){
					this.formData.chanpinDescription = item
					this.isShowChanpin = true
				}
				if (type == 'fengmian'){
					this.formData.fengmianDescription = item
					this.isShowFengmian = true
				}
			},
			handleRemove(file) {
				const { name, id } = file;
				const arr2 = this.fileList;
				for (let i = 0, len = arr1.length; i < len; i++) {
					if (arr1[i].accessoryName === name) {
						arr1.splice(i, 1);
						break;
					}
				}
				for (let i = 0, len = arr2.length; i < len; i++) {
					if (arr2[i].name === name) {
						arr2.splice(i, 1);
						break;
					}
				}
				if (this.dialogType !== "edit") return;
				this.removeFile(id);
			},
			handleSuccess(response, file, fileList) {
				const { code, data } = response;
				if (code === 200) {
					const { fileName, accessoryUrl, uploadTime } = data
					const obj = {
						accessoryName: fileName,
						accessoryUrl: accessoryUrl,
						uploadTime: uploadTime,
					};
					if (this.type == 'fengmian'){
						this.fengmianUrl = accessoryUrl
					} else {
						this.chanpinUrl = accessoryUrl
					}
					this.$message.success('上传成功！')
				} else {
					this.$message.error(data)
				}
			},
			beforeUpload(type){
				this.type=type
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
</style>
